import DynamicForm, { FormValuesOutput } from '@policygenius/mortar-dynamic-forms';
import { useCreateDataPointValues, useGetDataPointValues } from 'api/hooks/useDataPointValues';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { completedNavigatorStep } from 'analytics/navigator';
import { StepName } from 'analytics/navigator/constants';
import DynamicFormWrapper from 'components/DynamicFormWrapper';
import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import { CONTINUE_ONLINE_FINANCES_PATH } from 'routes/constants';
import useSelector from 'store/useSelector';

import { INTERVIEW_URNS } from './constants';
import schema from './schema';
import { FormValues } from './types';
import buildInitialValues from './utils/buildInitialValues';
import formatSubmitPayload from './utils/formatSubmitPayload';

const HazardousActivities: React.FC = () => {
  const navigate = useNavigate();
  const activeUserUuid = useSelector((app) => app.activeUserUuid);

  const { data, loading } = useGetDataPointValues({
    params: {
      urns: INTERVIEW_URNS,
    },
  });
  const { createDataPointValues } = useCreateDataPointValues({
    onCompleted: () => {
      completedNavigatorStep(StepName.HAZARDOUS_ACTIVITIES, activeUserUuid);
      navigate(`../${CONTINUE_ONLINE_FINANCES_PATH}`);
    },
  });

  if (loading) {
    return <GlobalLoader />;
  }

  const onSubmit = async (values: FormValuesOutput<FormValues>) => {
    await createDataPointValues(formatSubmitPayload(values));
  };

  const initialValues = buildInitialValues(data?.dataPointValues);

  return (
    <NavigatorContent>
      <DynamicFormWrapper title="Hazardous activities">
        <DynamicForm<FormValues>
          name="hazardous-activities"
          schema={schema}
          initialValues={initialValues}
          onSubmit={onSubmit}
        />
      </DynamicFormWrapper>
    </NavigatorContent>
  );
};

export default HazardousActivities;
